import copy from "copy-to-clipboard"
import toast from "react-hot-toast"
import { publicRosterPath } from "~/common/paths"

// The full public media kit URL an agency shares outside Zano (ZAN-929).
export const publicMediaKitUrl = (agencySlug: string) =>
  `${window.location.origin}${publicRosterPath({ agencySlug })}`

export const copyMediaKitLink = (url: string) => {
  if (copy(url)) {
    toast.success("Copied URL to clipboard")
  } else {
    toast.error("Couldn't copy the link. Copy the URL shown instead.")
  }
}

// Shown once an agency generates its media kit, so the URL is in front of
// them with a way to copy it. It outlives the redirect to the media kit,
// because the toaster sits above the router.
export const announceGeneratedMediaKit = ({
  url,
  publiclyViewable,
}: {
  url: string
  publiclyViewable: boolean
}) => {
  toast.success(
    (t) => (
      <div className="flex flex-col gap-2">
        <p>
          {publiclyViewable
            ? "Your media kit is ready to share:"
            : "Your media kit is generated, but visitors can't see it until your plan is active. Its link:"}
        </p>
        <p className="break-all font-medium">{url}</p>
        <button
          type="button"
          className="self-start underline"
          onClick={() => {
            copyMediaKitLink(url)
            toast.dismiss(t.id)
          }}
        >
          Copy link
        </button>
      </div>
    ),
    { duration: 10000 }
  )
}
